/**
 * Transforme la réponse de GET /hr/pilotage/taches en modèle
 * consommé par TachesSection.
 */
export const mapTaches = (api) => {
    const vacancesAllouees = api.vacation_allocated ?? 0;
    const vacancesConsommees = api.vacation_taken ?? 0;
    const vacancesDisponibles = api.vacation_available ?? 0;

    return {
        absencesJour: api.absences_today ?? 0,
        absencesJourPrevious: api.absences_today_previous ?? null,
        tachesEchues: api.overdue_tasks ?? 0,
        tachesEchuesPrevious: api.overdue_tasks_previous ?? null,
        vacancesAllouees,
        vacancesAlloueesPrevious: api.vacation_allocated_previous ?? null,
        vacancesAlloueesPct:
            vacancesAllouees > 0
                ? Math.round((vacancesAllouees / vacancesDisponibles) * 100)
                : 0,
        vacancesConsommees,
        vacancesConsommeesPrevious: api.vacation_taken_previous ?? null,
        vacancesDisponibles,
        vacancesDisponiblesPrevious: api.vacation_available_previous ?? null,
        vacancesConsommeesPct:
            vacancesAllouees > 0
                ? Math.round((vacancesConsommees / vacancesAllouees) * 100)
                : 0,
        validationFeuilles: api.timesheet_validation_pct ?? 0,
        validationFeuillesPrevious:
            api.timesheet_validation_pct_previous ?? null,
        envoiFeuilles: api.timesheet_submission_pct ?? 0,
        envoiFeuillesPrevious: api.timesheet_submission_pct_previous ?? null,
        onboardingsEnCours: api.onboardings_in_progress ?? 0,
        onboardingsEnCoursPrevious: api.onboardings_in_progress_previous ?? null,
        offboardingsEnCours: api.offboardings_in_progress ?? 0,
        offboardingsEnCoursPrevious:
            api.offboardings_in_progress_previous ?? null,
    };
};
